module.exports = __webpack_public_path__ + "img/awning-01.f1df0483.png";